// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lg7xX","fullView":"styles_fullView__L_e2_"};